module.exports = __webpack_public_path__ + "assets/img/newLogintit.3d23a161.png";